import { render, staticRenderFns } from "./ReleaseNotes.vue?vue&type=template&id=606bc6c8&scoped=true&"
import script from "./ReleaseNotes.vue?vue&type=script&lang=ts&"
export * from "./ReleaseNotes.vue?vue&type=script&lang=ts&"
import style0 from "./ReleaseNotes.vue?vue&type=style&index=0&id=606bc6c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606bc6c8",
  null
  
)

export default component.exports